<template>
    <div class="column" :id="image">
        <h2>{{title}}</h2>
        <p>{{description}}</p>
    </div>
</template>

<script>
export default {
   props: ['title', 'description', 'image'] 
}
</script>

<style lang="scss" scoped>
.column {
    border: 1px solid #bdc3c7;
    height: 35rem;
    width: 30%;
    z-index: 10;
    box-sizing: border-box;
    padding: 2rem;
    margin-right: 1rem;
    h2 {
        font-family: 'Aleo-bold';
        font-size: 2rem;
        background: #fff;
        text-transform: uppercase;
        padding: 1rem;
    }
    p {
        font-size: 1.5rem;
        color: #fff;
    }
    &#food-1 {
        background: url('~@/assets/images/food4.jpg');
    }
    &#food-2 {
        background: url('~@/assets/images/soep.jpg');
    }
    &#food-3 {
        background: url('~@/assets/images/dimsum.jpg');
    }
    &#food-4 {
        background: url('~@/assets/images/varken.jpeg');
    }
    &#food-5 {
        background: url('~@/assets/images/kip.jpeg');
    }
    &#food-6 {
        background: url('~@/assets/images/rund.jpg');
    }
    &#food-7 {
        background: url('~@/assets/images/vis.jpeg');
    }
    &#food-8 {
        background: url('~@/assets/images/eend.jpg');
    }
    &#food-9 {
        background: url('~@/assets/images/canton.jpeg');
    }
    &#food-10 {
        background: url('~@/assets/images/groente.jpg');
    }
    &#food-11 {
        background: url('~@/assets/images/bami.jpg');
    }
}
@media screen and (max-width: 600px) {
    .column{
        display: none;
    }
}
</style>
